import React from "react"; // eslint-disable-line
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _actions from "../../actions";
import VersionBox from "../../components/common/VersionBox";
import HorizontalFormContainer from "../../components/forms/HorizontalFormContainer";
import OnOffSwitch from "../../components/forms/OnOffSwitch";
import constants from "../../constants";
import PreviewEnableModules from "../../components/preview/PreviewEnableModules";
import i18n from "../../i18n";
import HelpTooltip from "../../components/common/HelpTooltip";
import { findCheckInFromMenus } from "../../utilities/utils";
import { checkPeopleModulesAccessible } from "../../utilities/utils";
import appStateProvider from "../../utilities/appStateProvider";
import { ENVIRONMENT } from "../../utilities/constants";

class EnableModules extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mainModules: [],
            sccrmModules: [],
            showPreview: true,
            hasStudioCConfigCalled: false,
        };
    }

    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getProjectVersionModules(
            this.props.match.params.projectId
        );
        this.props.actions.getProjectVersionMenuItems(
            this.props.match.params.projectId
        );
    }

    componentDidUpdate(prevProps) {
        if (this.props.modules.allInProgress !== prevProps.modules.allInProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                mainModules: this.props.modules.data.filter((module) => {
                    return this.isInModuleGroup("Core", module.moduleType);
                }),
            });
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                sccrmModules: this.props.modules.data.filter((module) => {
                    return this.isInModuleGroup("Chms", module.moduleType);
                }),
            });
        }

        const appState = appStateProvider();
        const environment = appState.getActiveEnvironment();
        if (
            !this.state.hasStudioCConfigCalled &&
            this.props.flags.results?.chMSIntegration &&
            this.props.flags.results?.studioC &&
            environment !== ENVIRONMENT.MY_PARISH_SOFT
        ) {
            this.setState({ hasStudioCConfigCalled: true });
            this.props.actions.getStudioCConfiguration();
        }
    }

    updateModuleFromEvent = (e, module) => {
        this.handleModuleChange("enabled", e.target.checked, module);
        this.props.modules.data = this.props.modules.data.map((mod) => {
            return {
                ...mod,
                enabled:
                    module.moduleType === mod.moduleType ? !mod.enabled : mod.enabled,
            };
        });

        // Handle Attendance module specifically, but only for live projects
        if (module.moduleType === 15 && this.props.projects?.selected?.liveVersion) {
            this.updatePendoAttendanceStatus(e.target.checked, module);
        }
    };

    updatePendoAttendanceStatus = (isEnabled, module) => {
        if (typeof window !== 'undefined' && window.pendo && typeof window.pendo.updateOptions === 'function') {
            try {
                window.pendo.updateOptions({
                    account: {
                        AB_AttendanceEnabled: isEnabled
                    }
                });
            } catch (error) {
                console.error('Error updating Pendo:', error);
            }
        }
    };

    handleModuleChange = (field, val, module) => {
        this.props.actions.updateModuleParameter(
            this.props.match.params.projectId,
            module.moduleType,
            field,
            val
        );
    };

    isInModuleGroup = (group, moduleType) => {
        return constants.ModuleType.some((module) => {
            return module.Group === group && module.Id === moduleType;
        });
    };

    checkForPeopleModule() {
        const modules = localStorage.getItem("ModulesData");
        const parsedModules = JSON.parse(modules);
        if (parsedModules !== null && parsedModules !== undefined) {
            const hasPeople = parsedModules.find((e) => e.name === "People");
            if (hasPeople !== undefined) {
                return true;
            }
            return false;
        }
    }

    isUnity() {
        const isUnity = localStorage.getItem("IsUnity");
        if (isUnity === "true") {
            return true;
        } else {
            return false;
        }
    }

    legacyOrUnityCheckForDisabledChms(unity, people) {
        if (unity === true && people === true) {
            return false;
        } else if (unity === true && people === false) {
            this.appBuilderStandaloneToggleOff();
            return true;
        } else {
            return !this.props.versions.select.chMSIntegrations;
        }
    }

    disableToggleForModule(arr) {
        if (arr?.length > 0) {
            arr[0].enabled = false;
        }
    }

    appBuilderStandaloneToggleOff() {
        const { data: modulesData } = this.props.modules;

        if (!modulesData || modulesData?.length === 0) return;

        const moduleTypes = [9, 11, 7]; //9, 11, 7 => people, groups, checkin(chmsIntegration)
        moduleTypes.forEach((moduleType) => {
            const modulesOfType = modulesData.filter(
                (module) => module.moduleType === moduleType
            );
            this.disableToggleForModule(modulesOfType);
        });
    }

    studioCToggleOff(checkChms) {
        const appState = appStateProvider();
        const environment = appState.getActiveEnvironment();
        switch (environment) {
            case ENVIRONMENT.MY_PARISH_SOFT:
                this.disableToggleForModule(14);
                return true; // true == studioC should not working
            case ENVIRONMENT.AMPLIFY:
            case ENVIRONMENT.LEGACY:
                if (checkChms === false) {
                    //false == checkChms is ONN then go in
                    const response = this.props.StudioC;
                    if (response.data) {
                        if (response.data?.userName && response.data?.domain) {
                            return false; //false == studioC should be working
                        } else {
                            return true; // true == studioC should not working
                        }
                    }
                } else return true; // true == studioC should not working
            default:
                return true; // true == studioC should not working
        }
    }

    getModuleNameById = (moduleId) => {
        const moduleType = constants.ModuleType.find((mt) => mt.Id === moduleId);
        return moduleType ? moduleType.Name : "";
    };

    generateModuleId = (moduleId) => {
        const moduleName = this.getModuleNameById(moduleId);
        return `enabled-tab-${moduleName.toLowerCase()}`;
    };
    generateModuleName = (moduleId) => {
        const moduleName = this.getModuleNameById(moduleId);
        return `${moduleName.toLowerCase()}`;
    };
    render() {
        const version = this.props.versions.select;
        let activeCheckin = findCheckInFromMenus(this.props.menuItems.data);
        const legOrUnity = this.isUnity();
        const hasPeople = this.checkForPeopleModule();
        const areDisabled = this.legacyOrUnityCheckForDisabledChms(
            legOrUnity,
            hasPeople
        );
        const isStudioCOff = this.studioCToggleOff(areDisabled);
        const isPeopleModulesAccessible = checkPeopleModulesAccessible();
        const appState = appStateProvider();
        const environment = appState.getActiveEnvironment();

        const previewModules = (
            <PreviewEnableModules
                primaryText={this.props.versions.select.primaryText}
                secondaryText={this.props.versions.select.secondaryText}
                menuStyle={version.menuStyle}
                menuItems={this.props.menuItems.data}
                churchName={this.props.versions.select.churchName}
                actionColor={this.props.versions.select.actionColor}
                accentColor={this.props.versions.select.accentColor}
                checkin={
                    this.props.flags.results?.chMSIntegration &&
                    this.props.flags.results?.chMSCheckIn &&
                    activeCheckin
                }
            />
        );

        const form = (
            <div
                id="enable-modules-form"
                className="form-wrapper"
                data-qa="enable-modules-form"
            >
                <h1 id="enable-modules-header" data-qa="enable-modules-header">
                    {i18n.t("modules.enable.header")}
                </h1>
                <p
                    id="enable-modules-subhead"
                    data-qa="enable-modules-subhead"
                    className="lead"
                >
                    {i18n.t("modules.enable.subtitle")}
                </p>

                <div className="general-section module-display-settings-list">
                    <h2 className="section-name">{i18n.t("modules.enable.section2")}</h2>
                    {this.state.mainModules.length > 0 &&
                        this.state.mainModules.map((module) => {
                            return (
                                <span key={module.moduleType}>
                                    <HorizontalFormContainer
                                        inputClass="module-display-setting__toggle"
                                        title={
                                            constants.ModuleType.find((mt) => {
                                                return mt.Id === module.moduleType;
                                            }).Name
                                        }
                                    >
                                        <OnOffSwitch
                                            id={this.generateModuleId(module.moduleType)}
                                            buttonClass="toggle checkbox md-checkbox"
                                            isToggleOn={module.enabled}
                                            name={this.generateModuleName(module.moduleType)}
                                            onChange={(e) => {
                                                this.updateModuleFromEvent(e, module);
                                                // eslint-disable-next-line no-param-reassign
                                                module.enabled = !module.enabled;
                                            }}
                                            dataQA={
                                                constants.ModuleType.find((mt) => {
                                                    return mt.Id === module.moduleType;
                                                }).Name
                                            }
                                            disabled={constants.ModuleType.some((mt) => {
                                                if (mt.Id === module.moduleType) {
                                                    let HasGive = localStorage.getItem("HasGiving");
                                                    if (
                                                        mt.Name === "Devotionals" &&
                                                        module.shareFaithMemberId === 0
                                                    )
                                                        return true;
                                                    else if (mt.Name === "Giving" && HasGive === "false")
                                                        return true;
                                                }
                                                return false;
                                            })}
                                        //tooltipText={i18n.t('modules.enable.devotional-module-help')}
                                        />
                                    </HorizontalFormContainer>
                                </span>
                            );
                        })}
                </div>
                {isPeopleModulesAccessible &&
                    this.props.flags.results &&
                    this.props.flags.results?.chMSIntegration &&
                    (this.props.flags.results?.chMSCheckIn ||
                        this.props.flags.results?.scPeople) && (
                        <div className="general-section module-display-settings-list">
                            <h2 className="section-name">
                                {i18n.t("modules.enable.section3")}{" "}
                                <HelpTooltip
                                    tooltipName="sccrm"
                                    tooltipText={i18n.t("modules.enable.sccrm-help")}
                                />
                            </h2>
                            {this.state.sccrmModules.length > 0 &&
                                this.state.sccrmModules.map((module) => {
                                    // Find the module type once and reuse it
                                    const moduleType = constants.ModuleType.find(
                                        (mt) => mt.Id === module.moduleType
                                    );
                                    const isStudioCModule =
                                        environment !== ENVIRONMENT.MY_PARISH_SOFT &&
                                        moduleType.Name === "StudioC";
                                    const tooltipName = moduleType.Name;

                                    const handleChange = (e) => {
                                        this.updateModuleFromEvent(e, module);
                                    };

                                    const isDisabled = isStudioCModule
                                        ? isStudioCOff
                                        : areDisabled;

                                    return (
                                        <span key={module.moduleType}>
                                            <HorizontalFormContainer
                                                inputClass={`module-display-setting__toggle ${isStudioCModule ? "studio-c-label" : ""
                                                    }`}
                                                title={moduleType.Name}
                                            >
                                                <OnOffSwitch
                                                    id={this.generateModuleId(module.moduleType)}
                                                    buttonClass="toggle checkbox md-checkbox"
                                                    isToggleOn={module.enabled}
                                                    name={this.generateModuleName(module.moduleType)}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                    tooltipText={i18n.t(
                                                        `modules.enable.sccrm-module-help.${tooltipName}`
                                                    )}
                                                    dataQA={moduleType.Name}
                                                />
                                            </HorizontalFormContainer>
                                        </span>
                                    );
                                })}
                        </div>
                    )}
            </div>
        );
        return (
            <VersionBox
                name={version.name}
                versionNumber={version.version}
                saving={
                    this.props.versions.inProgress ||
                    this.props.versions.validationInProgress
                }
                justSaved={this.props.modules.justSaved}
                menuSection="Modules"
                menuItem="EnableModules"
                previewCssClass="modules_enable-modules"
                previewChild={previewModules}
                configCode={this.props.versions.select.configCode}
                showPreview={this.state.showPreview}
                x
            >
                <div id="enable-modules-page" className="content-inside">
                    {form}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnableModules);
